export function defaultOrderDateRange(now = new Date()) {
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat("en-CA", {
      timeZone: "Asia/Kuala_Lumpur",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
      .formatToParts(now)
      .map((part) => [part.type, part.value]),
  );
  const year = Number(parts.year),
    month = Number(parts.month),
    day = Number(parts.day);
  const previous = new Date(Date.UTC(year, month - 2, 1));
  const lastDay = new Date(Date.UTC(year, month - 1, 0)).getUTCDate();
  const pad = (value) => String(value).padStart(2, "0");
  return {
    dateFrom: `${previous.getUTCFullYear()}-${pad(
      previous.getUTCMonth() + 1,
    )}-${pad(Math.min(day, lastDay))}`,
    dateTo: `${parts.year}-${parts.month}-${parts.day}`,
  };
}
